export class ApiKeyModel {
    public API_KEY: string;
}